import { render, staticRenderFns } from "./MlocalidadGrid.vue?vue&type=template&id=1977dd18"
import script from "./MlocalidadGrid.vue?vue&type=script&lang=js"
export * from "./MlocalidadGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports